import React, { useState, useEffect } from 'react';
import './AppDownloadBanner.css';

function AppDownloadBanner({ mediaType, filmId, userId, inviterId }) {
  const [showBanner, setShowBanner] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Détecter si l'utilisateur est sur mobile
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
      const ios = /iphone|ipad|ipod/.test(userAgent);
      
      // Ne pas afficher la bannière custom sur iOS car la Smart App Banner native gère déjà cela
      return mobile && !ios;
    };

    const shouldShowBanner = checkMobile();
    setIsMobile(shouldShowBanner);
    
    // Afficher le banner seulement sur mobile non-iOS (Smart App Banner native gère iOS)
    if (shouldShowBanner) {
      setShowBanner(true);
    }
  }, []);

  const tryOpenApp = () => {
    // Générer le deep link approprié
    let deepLink = '';
    if (mediaType && filmId) {
      deepLink = `cinemapp://${mediaType}/${filmId}`;
    } else if (userId) {
      deepLink = `cinemapp://user/${userId}`;
    } else if (inviterId) {
      deepLink = `cinemapp://compat-invite/${inviterId}`;
    }

    if (deepLink) {
      // Tenter d'ouvrir l'app
      window.location.href = deepLink;
      
      // Si l'app ne s'ouvre pas, rediriger vers l'App Store après un délai
      setTimeout(() => {
        redirectToStore();
      }, 2000);
    } else {
      redirectToStore();
    }
  };

  const redirectToStore = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    
    if (/iphone|ipad|ipod/.test(userAgent)) {
      // Redirection vers l'App Store iOS
      window.location.href = 'https://apps.apple.com/fr/app/cin%C3%A9list/id6740208004?l=en-GB';
    } else if (/android/.test(userAgent)) {
      // Redirection vers Google Play Store
      window.location.href = 'https://play.google.com/store/apps/details?id=com.cinemapp'; // Remplacer par l'ID réel
    }
  };

  const closeBanner = () => {
    setShowBanner(false);
  };

  if (!showBanner || !isMobile) {
    return null;
  }

  return (
    <div className="app-download-banner">
      <div className="banner-content">
        <div className="banner-icon">
          <img src="/logo192.png" alt="CinemApp" className="app-icon" />
        </div>
        <div className="banner-text">
          <h4>CinemApp</h4>
          <p>Meilleure expérience dans l'app</p>
        </div>
        <div className="banner-actions">
          <button onClick={tryOpenApp} className="open-app-btn">
            Ouvrir
          </button>
          <button onClick={closeBanner} className="close-banner-btn">
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppDownloadBanner;